export const CommercialAddonType = {
  Insurance: 'insurance',
  Wellness: 'wellness',
  Voluntary: 'voluntary'
} as const;

export type CommercialAddonType = (typeof CommercialAddonType)[keyof typeof CommercialAddonType];

export type AddonTypeById = Map<number, CommercialAddonType>;

export type CommercialAddonEntity = 'addon' | 'plan';

export const CommercialPlanBundleType = {
  AppOnly: 'app_only',
  Insurance: 'insurance'
} as const;

export type CommercialPlanBundleType = (typeof CommercialPlanBundleType)[keyof typeof CommercialPlanBundleType];

export const CensusVariant = {
  Insurance: 'insurance',
  AppOnly: 'app_only'
} as const;

export type CensusVariant = (typeof CensusVariant)[keyof typeof CensusVariant];

export type TobaccoStatus = 'composite' | 'non_tobacco' | 'tobacco';

export type QuoteStatus = 'created' | 'accepted' | 'lost' | 'inactive' | 'active';

export type QuoteFileType = 'quote' | 'census_simple' | 'census' | 'external';

export const QuoteDocumentType = {
  Demographics: 'demographics',
  EnrollmentReport: 'enrollment_report',
  DemographicsWithDependents: 'demographics_with_dependents',
  Deductions: 'deductions',
  Sbc: 'sbc',
  Other: 'other'
} as const;

export type QuoteDocumentType = (typeof QuoteDocumentType)[keyof typeof QuoteDocumentType];

export type ExternalBenefitsState = 'none' | 'in_review';

export type AgeInputMode = 'average' | 'census';

// ─── Activation census validation ────────────────────────────────────────────

export const ActivationCensusProcessType = {
  BulkEnrollment: 'bulkEnrollment',
  BulkEnrollmentValidation: 'bulkEnrollmentValidation',
  BulkInvitationCodesCreation: 'bulkInvitationCodesCreation'
} as const;

export type ActivationCensusProcessType =
  (typeof ActivationCensusProcessType)[keyof typeof ActivationCensusProcessType];

export const ActivationCensusValidationStatus = {
  Pending: 'pending',
  InProgress: 'inProgress',
  Sent: 'sent',
  Completed: 'completed'
} as const;

export type ActivationCensusValidationStatus =
  (typeof ActivationCensusValidationStatus)[keyof typeof ActivationCensusValidationStatus];
